var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Plotly',{attrs:{"data":_vm.data,"layout":_vm.layout,"displayModeBar":_vm.displayModeBar,"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }